// Первый вход (встреча 24.10.2026): пароль, выданный администратором, — временный, человек сам задаёт логин
// и пароль; вход по ссылке-приглашению с телефона прораба и значок на главном экране.

import { useEffect, useState } from "react";
import { errorText } from "../../shared/api";
import { InstallButton } from "../../shared/install";
import { navigate } from "../../shared/router";
import { Button, Field, Input } from "../../shared/ui";
import { api, type Me } from "../ctx";

/** Открыли ссылку `#/invite/<код>`: входим по ней один раз, затем — свой пароль. */
export function InviteScreen({ token, onDone }: { token: string; onDone: () => void }) {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let off = false;
    api.logout(); // ссылка — для другого человека: прежний вход на этом устройстве закрываем
    api.loginWith("/auth/invite", { token })
      .then(() => { if (!off) { navigate("/"); onDone(); } })
      .catch((e) => { if (!off) setError(errorText(e)); });
    return () => { off = true; };
  }, [token, onDone]);
  return (
    <div className="login">
      <div className="box">
        <h1>Стройка</h1>
        {error ? (
          <>
            <div className="alert risk" role="alert"><div className="t">{error}</div></div>
            <Button variant="primary" onClick={() => { navigate("/"); location.reload(); }}>Войти по логину и паролю</Button>
          </>
        ) : <p className="muted">Входим по ссылке…</p>}
      </div>
    </div>
  );
}

/** «Фамилия Имя Отчество» → «, Имя Отчество»; иначе — как записано. */
function greet(full: string): string {
  const p = full.trim().split(/\s+/);
  return p.length === 3 && /^[А-ЯЁ]/.test(p[1]) ? `, ${p[1]} ${p[2]}` : full.trim() ? `, ${full.trim()}` : "";
}

/** Свой логин и пароль на первом входе; после — подсказка поставить значок на главный экран. */
export function FirstLoginScreen({ me, onDone, onLogout }: { me: Me; onDone: () => void; onLogout: () => void }) {
  const [login, setLogin] = useState(me.login);
  const [pass, setPass] = useState("");
  const [again, setAgain] = useState("");
  const [shown, setShown] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const mismatch = again !== "" && pass !== again;
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      const tokens = await api.post("/me/credentials", { login: login.trim() !== me.login ? login.trim() : null, password: pass });
      api.tokens = tokens;
      onDone();
    } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };
  return (
    <div className="login">
      <form className="box" onSubmit={submit}>
        <h1>Здравствуйте{greet(me.full_name)}</h1>
        <p className="small muted" style={{ margin: 0 }}>Пароль вам выдал администратор — придумайте свой. Логин можно оставить или поменять.</p>
        <Field label="Логин" hint="Латиницей; им вы будете входить"><Input autoComplete="username" value={login} onChange={(e) => setLogin(e.target.value)} /></Field>
        <Field label="Новый пароль" hint="Не меньше 6 знаков">
          <div className="row tight" style={{ flexWrap: "nowrap" }}>
            <Input className="grow" type={shown ? "text" : "password"} autoComplete="new-password" autoFocus value={pass} onChange={(e) => setPass(e.target.value)} />
            <Button size="small" aria-pressed={shown} onClick={() => setShown(!shown)}>{shown ? "Скрыть" : "Показать"}</Button>
          </div>
        </Field>
        <Field label="Повторите пароль" error={mismatch ? "Пароли не совпадают" : null}>
          <Input type={shown ? "text" : "password"} autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} />
        </Field>
        {error && <div className="alert risk" role="alert"><div className="t">{error}</div></div>}
        <Button type="submit" variant="primary" disabled={busy || pass.length < 6 || pass !== again || login.trim().length < 2}>Сохранить и войти</Button>
        <div className="row between small">
          <InstallButton name="Приложение «Стройка»" />
          <Button variant="ghost" size="small" onClick={onLogout}>Выйти</Button>
        </div>
      </form>
    </div>
  );
}
